import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPaymentToEdit } from '../../states/payments/builders';

const mapState = (state) => ({
	paymentsToEdit: getPaymentToEdit(state),
});

export class EditPayment extends Component {
	componentDidMount() {
		const {
			paymentsToEdit: { paymentType, payments, paymentDetails },
			handleEdit,
		} = this.props;
		handleEdit(paymentType, { payments, paymentDetails });
	}
	render() {
		return null;
	}
}

EditPayment.propTypes = {
	paymentsToEdit: PropTypes.shape({}),
	handleEdit: PropTypes.func.isRequired,
};

export default connect(mapState)(EditPayment);
